module.exports = __webpack_public_path__ + "static/media/cancel-package_2.fd2cd41c.png";